/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryFolderResponse } from './RevisdomAPIViewModelsEntryFolderResponse';
import {
    RevisdomAPIViewModelsEntryFolderResponseFromJSON,
    RevisdomAPIViewModelsEntryFolderResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryFolderResponseToJSON,
    RevisdomAPIViewModelsEntryFolderResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryFolderResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1FolderResponse
 */
export interface ApiResponse1FolderResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1FolderResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1FolderResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryFolderResponse}
     * @memberof ApiResponse1FolderResponse
     */
    data?: RevisdomAPIViewModelsEntryFolderResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1FolderResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1FolderResponse interface.
 */
export function instanceOfApiResponse1FolderResponse(value: object): value is ApiResponse1FolderResponse {
    return true;
}

export function ApiResponse1FolderResponseFromJSON(json: any): ApiResponse1FolderResponse {
    return ApiResponse1FolderResponseFromJSONTyped(json, false);
}

export function ApiResponse1FolderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1FolderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryFolderResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1FolderResponseToJSON(json: any): ApiResponse1FolderResponse {
    return ApiResponse1FolderResponseToJSONTyped(json, false);
}

export function ApiResponse1FolderResponseToJSONTyped(value?: ApiResponse1FolderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryFolderResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

